import { requiredFieldValidation } from 'app/validation/validation';

export const resetPasswordFormValidation = {
  email: {
    required: requiredFieldValidation,
  },
};
